import { Amount } from "@ssc-booking/api-contracts"
import { t } from "@lingui/macro"
import { match } from "ts-pattern"
import * as O from "fp-ts/Option"
import { Receipt, SuitePriceFrom, SuitePriceTotal } from "../v3/_common/machines/receipt-machine"

export type PriceInfoStatus = "loading" | "loaded"
export type PriceInfo = {
    label: string
    showDetails: boolean
    originalAmount: O.Option<Amount>
    amount: Amount
    status: PriceInfoStatus
}

const priceInfoFrom =
    (status: PriceInfoStatus, extendedLabel: boolean) =>
    (recipt: SuitePriceFrom): PriceInfo => ({
        label: extendedLabel ? t`Price from` : t`From`,
        showDetails: false,
        amount: recipt.price.total,
        originalAmount: recipt.price.originalTotal,
        status: status,
    })

const priceInfoTotal =
    (status: PriceInfoStatus, extendedLabel: boolean) =>
    (recipt: SuitePriceTotal): PriceInfo => ({
        label: t`Total price`,
        showDetails: true,
        amount: recipt.price.total,
        originalAmount: recipt.price.originalTotal,
        status: status,
    })

export const getPriceInfo = (recipt: Receipt, loading: boolean, extendedLabel?: boolean): PriceInfo =>
    match(recipt)
        .with({ type: "price-from" }, priceInfoFrom(loading ? "loading" : "loaded", !!extendedLabel))
        .with({ type: "price-total" }, priceInfoTotal(loading ? "loading" : "loaded", !!extendedLabel))
        .exhaustive()
